import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/core/api/envelope';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: (count, error) => {
        if (error instanceof ApiError && ['auth', 'permission', 'validation'].includes(error.kind)) {
          return false;
        }
        return count < 2;
      },
    },
  },
});
